module.exports = __webpack_public_path__ + "img/arrow_right_brand.ca164104.svg";